import { useDispatch, useSelector } from 'react-redux';
import { axiosInstance, encodeValue, formatDate } from '../../../utils/helper';
import { BikeIcon, LoaderIcon, StarIcon, UFoodIcon, UltraVoucherIcon } from '../../../utils/svg';
import ImageLoader from '../../../components/ImageLoader';
import { Rating as SimpleRating } from 'react-simple-star-rating';
import { useState } from 'react';
import { uniqueID } from '../../../utils/constants'; 
import qs from 'qs';
import { getOrderList } from '../../../store/reducers/order';

const Rating = ({ order = {}, callback = (rating = 0) => {} }) => {
  const dispatch = useDispatch();
	const tab = useSelector((store) => store?.order?.tab);
	const user = useSelector((store) => store?.user);
	const [rating, setRating] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = () => {
		console.log('handleSubmit');
		setIsLoading(true);

		const data = {
			unquieid: uniqueID,
			customerID: encodeValue(user?.customerID),
			orderID: encodeValue(order?.order_primary_id),
			rating: rating,
		};

		console.log('data: ', data);

		axiosInstance
			.post('orders/createRating', qs.stringify(data))
			.then((res) => {
				console.log('res', res);
				if (res.data.status === 'ok') {
          dispatch(
            getOrderList({
              unquieid: uniqueID,
              customerID: encodeValue(user?.customerID),
            }),
          );
          callback();
				}
			})
			.catch((error) => {
				console.log('error', error);
				setIsLoading(false);
			});
	};

	return (
		<>
			<div className='w-full p-4 flex justify-between items-center'>
				<UFoodIcon />
				<p className='text-sm font-semibold text-gray-700'>Pengantaran Berhasil</p>
			</div>
			<div className='w-full px-4 flex justify-between items-center bg-gray-100 h-9 text-xs'>
				<p>{formatDate(order?.order_date || order?.created_on, 'D MMM YYYY, HH:mm A')}</p>
				<p>Order ID {order?.orderNumber}</p>
			</div>
			<div className='w-full p-4 flex'>
				<div className='product-img rounded-xl'>{tab === 'pesanan' ? <ImageLoader src={order?.store?.[0]?.image} alt={order?.store?.[0]?.name} /> : <UltraVoucherIcon className='h-full w-full rounded-xl object-cover object-center' />}</div>
				<div className='ml-3'>
					<h2 className='text-base font-semibold pt-1'>{order?.store?.[0]?.name}</h2>
					<p className='text-xs font-normal'>Makanan dan Minuman</p>
					<div className='flex gap-1 items-center mt-1'>
						<BikeIcon />
						<p className='text-xs font-semibold hidden'>0.8 km</p>
					</div>
				</div>
			</div>
			<div className='w-full px-4'>
				<div className='w-full flex flex-col items-center justify-center py-3 border-1 border-solid border-gray-300 rounded-md'>
					<h3 className='text-sm font-semibold mb-4'>Yuk, kasih nilai!</h3>
					<SimpleRating initialValue={parseFloat(order?.rating)} onClick={setRating} transition allowFraction emptyIcon={<StarIcon className={'inline h-9 w-9'} />} fillIcon={<StarIcon className={'inline h-9 w-9'} />} />
				</div>
				<button
					className={`w-full text-sm font-semibold py-3 rounded my-7 flex justify-center items-center 
            ${!rating ? 'bg-gray-300 text-gray-500 cursor-not-allowed border border-gray-300' : 'bg-[var(--rose-violet)] text-white cursor-pointer'}
          `}
					onClick={handleSubmit}
					disabled={!rating}>
					{isLoading ? <LoaderIcon /> : 'Simpan'}
				</button>
			</div>
		</>
	);
};

export default Rating;
